import CollectionIcon from "@/icons/CollectionIcon";
import CheckIcon from "@/icons/CheckIcon";
import LockCloseIcon from "@/icons/LockClosedIcon";

const FILES_TYPES = [
  {
    label: "Все",
    value: "all",
    icon: <CollectionIcon style={{ fontSize: 14 }} />,
  },
  {
    label: "Вы участник",
    value: "root",
    icon: <CheckIcon style={{ fontSize: 14 }} />,
  },
  {
    label: "Вы читатель",
    value: "child",
    icon: <LockCloseIcon style={{ fontSize: 14 }} />,
  },
];

const LOCAL_STORAGE_KEY = "filesTableParams";

export { FILES_TYPES, LOCAL_STORAGE_KEY };
